import { createContext } from 'react';

export const PasswordlessLoginTokenContext = createContext<{
  passwordlessLoginToken: string | null;
}>({
  passwordlessLoginToken: null,
});
